import { GetPendingWorkResponse } from "@syla/shared/types/responses/GetPendingWorkResponse";
import axios from "axios";

export const getPendingWork = async (
  accountId: string
): Promise<GetPendingWorkResponse> => {
  return (await axios.get(`/accounts/${accountId}/status/pendingWork`)).data;
};
